import { useEffect, useState } from "react";

export const EASE_OUT = [0.22, 1, 0.36, 1];

export const SPRING_POP = { type: "spring", stiffness: 380, damping: 28 };

export const INSTANT = { duration: 0 };

export const STAGGER_CAP = 12;

export function useMotionPrefs() {
  const [isReduced, setIsReduced] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setIsReduced(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return { enabled: !isReduced, isReduced };
}

export function withMotionPrefs(variants, isReduced) {
  if (!isReduced) return variants;
  const reduced = {};
  for (const key of Object.keys(variants)) {
    const v = variants[key];
    reduced[key] = {
      ...v,
      transition: INSTANT,
      opacity: key === "hidden" ? v.opacity ?? 0 : 1,
      x: 0,
      y: 0,
      scale: 1,
    };
  }
  return reduced;
}

export const fadeUp = {
  hidden: { opacity: 0, y: 12 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.32, ease: EASE_OUT },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { duration: 0.28, ease: EASE_OUT },
  },
};

export const slideIn = {
  hidden: { opacity: 0, x: 16 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.3, ease: EASE_OUT },
  },
};

export const pageTransition = {
  hidden: { opacity: 0, y: 12 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.28, ease: EASE_OUT },
  },
  exit: {
    opacity: 0,
    y: -8,
    transition: { duration: 0.18, ease: EASE_OUT },
  },
};

export const staggerContainer = (delayChildren = 0.04) => ({
  hidden: {},
  show: {
    transition: {
      staggerChildren: delayChildren,
      delayChildren: 0.02,
    },
  },
});

export const staggerItem = {
  hidden: { opacity: 0, y: 10 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.28, ease: EASE_OUT },
  },
};

export const popSuccess = {
  hidden: { scale: 0.92, opacity: 0.6 },
  show: {
    scale: 1,
    opacity: 1,
    transition: SPRING_POP,
  },
};

export const tap = { scale: 0.97 };

export function cappedStaggerIndex(index) {
  return index >= STAGGER_CAP ? 0 : index;
}
